<style lang="scss" scoped>
.contianer {
	width: 100%;
	height: 1190px;
	box-sizing: border-box;
	text-align: center;
}
.more-experirence-title {
	margin-top: 160px;
	margin-bottom: 30px;
}
.more-experirence-content {
	position: relative;
	width: 1297px;
	height: 867px;
	margin: 0 auto;
	background: url('../../assets/pc/more-experirence-content-bg.png');
	padding-top: 55px;
  box-sizing: border-box;
	.more-experirence-icon1 {
		position: absolute;
		right: -233px;
    top: 280px;
	}
	.more-experirence-icon2 {
		position: absolute;
		right: -110px;
    bottom: 195px;
	}
	.more-experirence-icon3 {
		position: absolute;
		left: -112px;
    top: -17px;
	}
	.more-experirence-icon4 {
		position: absolute;
		left: -152px;
    bottom: 232px;
	}
}
.switch-items {
	width: 100%;
	height: 75px;
	line-height: 75px;
	padding-left: 90px;
	box-sizing: border-box;
	margin-bottom: 15px;
	.switch-item {
		float: left;
		padding-left: 25px;
		padding-right: 25px;
		letter-spacing: 20px;
		color: #ffeeca;
		font-size: 34px;
		cursor: pointer;
		&:hover {
			color: #bd4f67;
			background: #fad2da;
		}
	}
	.switch-item-choose {
		color: #bd4f67;
		background: #fad2da;
	}
}
.result-list {
	width: 1100px;
	line-height: 50px;
	overflow: auto;
	border-bottom: 1px solid #bd4f67;
	margin-top: 15px;
	margin-left: 90px;
	text-align: left;
	padding-left: 8px;
	cursor: pointer;
	font-size: 24px;
	text-shadow: 0 0 1px #bd4f67;
	letter-spacing: 2px;
	.new-icon {
		float: left;
    width: 70px;
    height: auto;
    margin-right: 45px;
    margin-top: 12px;
	}
	span {
		color: #bd4f67;
	}
}
.go-page {
	width: 100%;
	height: 25px;
	text-align: right;
	margin-top: 20px;
	padding-right: 97px;
  box-sizing: border-box;
	.go-page-btn {
		margin-left: 80px;
		cursor: pointer;
	}
}
</style>

<template>
	<div class="p-more-experirence pc-common-bg">
		<div class="contianer">
			<img class="more-experirence-title" src="../../assets/pc/more-experirence-title.png" alt="">
			<div class="more-experirence-content">
				<img class="more-experirence-icon1" src="../../assets/pc/more-experirence-icon1.png" alt="">
				<img class="more-experirence-icon2" src="../../assets/pc/more-experirence-icon2.png" alt="">
				<img class="more-experirence-icon3" src="../../assets/pc/more-experirence-icon3.png" alt="">
				<img class="more-experirence-icon4" src="../../assets/pc/more-experirence-icon4.png" alt="">
				<div class="switch-items">
					<div 
						v-for="item in switchItemList" 
						:key="item.columnId" 
						:class="{'switch-item-choose': postData.columnId == item.columnId}" 
						@click="chooseItem(item.columnId)" 
						class="switch-item"
					>{{item.columnName}}</div>
				</div>
				<div 
					v-for="item in resultList" 
					:key="item.newsId" 
					@click="$router.push({name: 'p-news-detail', params: {newsId: item.newsId} })" 
					class="result-list"
				>
					<img v-show="item.wasNew == '1'" class="new-icon" src="../../assets/pc/news.png" alt="">
					<span>{{item.newsTitle}}</span>
				</div>
				<div class="go-page">
					<img @click="goPreview" class="go-page-btn preview-page" src="../../assets/pc/preview-page.png" alt="">
					<img @click="goNext" class="go-page-btn next-page" src="../../assets/pc/next-page.png" alt="">
				</div>
			</div>
		</div>
		<p-footer></p-footer>
	</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-more-experirence',
	components: {
		'p-footer': Footer
	},
	data() {
		return {
			switchItemList: [],
			resultList: [],
			postData:{
				page: 1,
				pageSize: 10,
				columnId: '',
				platform: "1"
			},
			pageNumber: 1
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.$http.get('/api/website/getColumn?platform=1').then((rsp) => {
				this.switchItemList = rsp.result.column;
				if(this.switchItemList.length > 0) {
					this.chooseItem(this.switchItemList[0].columnId);
				}
			});
		},
		chooseItem(id) {
			this.postData.page = 1;
			this.postData.columnId = id;
			this.getList();
		},
		goNext() {
			if(this.postData.page < this.pageNumber) {
				this.postData.page++;
				this.getList();
			} else {
				this.$Message.warning('没有更多了哦');
			}
		},
		goPreview() {
			if(this.postData.page != 1) {
				this.postData.page--;
				this.getList();
			} else {
				this.$Message.warning('没有上一页哦');
			}
		},
		getList() {
			this.$http.post('/api/website/getNewsList', this.postData).then((rsp) => {
				this.resultList = rsp.result.newsList.list;
				this.pageNumber = rsp.result.newsList.pages;
			});
		}
	},
}
</script>